<template>
  <path
    fill="currentColor"
    d="M7.03697 5.2678C7.28736 5.0302 7.69333 5.0302 7.94372 5.2678C8.19411 5.50539 8.19411 5.89061 7.94372 6.12821L4.52206 9.375L16.7401 9.375C17.0853 9.375 17.3651 9.65482 17.3651 10C17.3651 10.3452 17.0853 10.625 16.7401 10.625L4.52196 10.625L7.94372 13.8719C8.19411 14.1095 8.19411 14.4947 7.94372 14.7323C7.69333 14.9699 7.28736 14.9699 7.03697 14.7323L2.50322 10.4303C2.25283 10.1927 2.25283 9.80744 2.50322 9.56985L7.03697 5.2678Z" />
</template>
